import { FC } from 'react';

const ActionIconSpeechBubble: FC = () => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 10.9945C1.65927 10.8966 1.8267 10.8142 2 10.748C2.34047 10.6178 2.7036 10.55 3.072 10.55H10C11.1046 10.55 12 9.65462 12 8.55005V0.550049H2.00001C0.895437 0.550049 8.25649e-06 1.44548 7.30219e-06 2.55005L0 12.002L1.398 11.06C1.4316 11.0375 1.46561 11.0156 1.5 10.9945ZM3.072 8.55005C2.70961 8.55005 2.35029 8.58941 2 8.66626L2.00001 3.05005C2.00001 2.77391 2.22386 2.55005 2.50001 2.55005H10V8.05005C10 8.32619 9.77614 8.55005 9.5 8.55005H3.072ZM5 4.50005C4.44772 4.50005 4 4.94776 4 5.50005C4 6.05233 4.44772 6.50005 5 6.50005H7C7.55228 6.50005 8 6.05233 8 5.50005C8 4.94776 7.55228 4.50005 7 4.50005H5Z"
      fill="currentColor"
    />
  </svg>
);

export { ActionIconSpeechBubble };
